<h2 mat-dialog-title>Zoning Code Validation Result</h2>

<div class="validation-errors-container">
    <zc-validation-result-table [data]="data"></zc-validation-result-table>
</div>

<div class="popup-footer">
    <div class="attributes-button-container">
        <button mat-dialog-close class="button">Cancel</button>
    </div>
</div>
